import { Radio } from 'antd'

export const PAYMENT_CURRENCY = {
  USD: 1,
  TWD: 2,
} as const

interface PaymentCurrencySelectorProps {
  value?: string
  onChange?: (value: string) => void
  disabled?: boolean
}

export function PaymentCurrencySelector({
  value = 'TWD',
  onChange,
  disabled = false,
}: PaymentCurrencySelectorProps) {
  return (
    <Radio.Group
      className="w-full grid grid-cols-2 gap-2"
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
    >
      <Radio
        value="USD"
        className="flex-1 flex items-center px-4 py-3 border border-gray100 rounded-lg hover:border-secondary [&.ant-radio-wrapper-checked]:border-secondary [&.ant-radio-wrapper-checked]:bg-highlight/10"
        disabled={disabled}
      >
        <div className="t-bold text-primary">USD($)</div>
      </Radio>
      <Radio
        value="TWD"
        className="flex-1 flex items-center px-4 py-3 border border-gray100 rounded-lg hover:border-secondary [&.ant-radio-wrapper-checked]:border-secondary [&.ant-radio-wrapper-checked]:bg-highlight/10"
        disabled={disabled}
      >
        <div className="t-bold text-primary">TWD(NT$)</div>
      </Radio>
    </Radio.Group>
  )
}
